import { createSlice } from '@reduxjs/toolkit';

const controlDefaults = {
  createGeofence: false,
};

const { reducer, actions } = createSlice({
  name: 'geofences',
  controls: controlDefaults,
  initialState: {
    items: {},
  },
  reducers: {
    refresh(state, action) {
      state.items = {};
      action.payload.forEach((item) => state.items[item.id] = item);
    },
    update(state, action) {
      action.payload.forEach((item) => state.items[item.id] = item);
    },
  },
});

export { actions as geofencesActions };
export { reducer as geofencesReducer };
